import { LivenessEventTypes } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'

/**
 * Friendly, translatable label for the gated action.
 *
 * The `eventType` values are a backend enum owned by `mmfintech-backend-api`;
 * only the copy mapping lives here. Status classification moved to the package
 * too — use `classifyLivenessStatus` from there.
 */
export const livenessEventLabel = (eventType?: string): string => {
  switch (eventType) {
    case LivenessEventTypes.CRYPTO_WITHDRAWAL:
      return tr('FRONTEND.LIVENESS.EVENT.CRYPTO_WITHDRAWAL', 'crypto withdrawal')
    case LivenessEventTypes.DORMANT_REACTIVATION:
      return tr('FRONTEND.LIVENESS.EVENT.DORMANT_REACTIVATION', 'account reactivation')
    case LivenessEventTypes.EMAIL_CHANGE:
      return tr('FRONTEND.LIVENESS.EVENT.EMAIL_CHANGE', 'email change')
    case LivenessEventTypes.PHONE_CHANGE:
      return tr('FRONTEND.LIVENESS.EVENT.PHONE_CHANGE', 'phone number change')
    default:
      return tr('FRONTEND.LIVENESS.EVENT.DEFAULT', 'this action')
  }
}
